/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { MenuOrderItem } from './MenuOrderItem';
import {
    MenuOrderItemFromJSON,
    MenuOrderItemFromJSONTyped,
    MenuOrderItemToJSON,
    MenuOrderItemToJSONTyped,
} from './MenuOrderItem';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { OrderRefund } from './OrderRefund';
import {
    OrderRefundFromJSON,
    OrderRefundFromJSONTyped,
    OrderRefundToJSON,
    OrderRefundToJSONTyped,
} from './OrderRefund';
import type { MenuOrderStatus } from './MenuOrderStatus';
import {
    MenuOrderStatusFromJSON,
    MenuOrderStatusFromJSONTyped,
    MenuOrderStatusToJSON,
    MenuOrderStatusToJSONTyped,
} from './MenuOrderStatus';
import type { MenuOrderDiscount } from './MenuOrderDiscount';
import {
    MenuOrderDiscountFromJSON,
    MenuOrderDiscountFromJSONTyped,
    MenuOrderDiscountToJSON,
    MenuOrderDiscountToJSONTyped,
} from './MenuOrderDiscount';
import type { MenuOrderServiceFee } from './MenuOrderServiceFee';
import {
    MenuOrderServiceFeeFromJSON,
    MenuOrderServiceFeeFromJSONTyped,
    MenuOrderServiceFeeToJSON,
    MenuOrderServiceFeeToJSONTyped,
} from './MenuOrderServiceFee';

/**
 * Represents a single menu order owned by users in the system.
 * @export
 * @interface MenuOrderOwn
 */
export interface MenuOrderOwn {
    /**
     * 
     * @type {string}
     * @memberof MenuOrderOwn
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderOwn
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderOwn
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderOwn
     */
    business: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderOwn
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderOwn
     */
    stripeTotal: number;
    /**
     * 
     * @type {Array<MenuOrderServiceFee>}
     * @memberof MenuOrderOwn
     */
    serviceFees?: Array<MenuOrderServiceFee>;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderOwn
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderOwn
     */
    deliveryCharge: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderOwn
     */
    tipDelivery?: number;
    /**
     * 
     * @type {Array<MenuOrderDiscount>}
     * @memberof MenuOrderOwn
     */
    discounts?: Array<MenuOrderDiscount>;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderOwn
     */
    transactionHash?: string;
    /**
     * 
     * @type {MenuOrderStatus}
     * @memberof MenuOrderOwn
     */
    status?: MenuOrderStatus;
    /**
     * 
     * @type {Address}
     * @memberof MenuOrderOwn
     */
    address: Address;
    /**
     * 
     * @type {HandoffOptions}
     * @memberof MenuOrderOwn
     */
    handoff?: HandoffOptions;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderOwn
     */
    pickupCode?: string;
    /**
     * 
     * @type {Array<MenuOrderItem>}
     * @memberof MenuOrderOwn
     */
    orderItems: Array<MenuOrderItem>;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrderOwn
     */
    callbackComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrderOwn
     */
    exceededSlippage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderOwn
     */
    uberEatsUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderOwn
     */
    orderUuid?: string;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof MenuOrderOwn
     */
    refunds?: Array<OrderRefund>;
}



/**
 * Check if a given object implements the MenuOrderOwn interface.
 */
export function instanceOfMenuOrderOwn(value: object): value is MenuOrderOwn {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('business' in value) || value['business'] === undefined) return false;
    if (!('subtotal' in value) || value['subtotal'] === undefined) return false;
    if (!('stripeTotal' in value) || value['stripeTotal'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('deliveryCharge' in value) || value['deliveryCharge'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('orderItems' in value) || value['orderItems'] === undefined) return false;
    if (!('callbackComplete' in value) || value['callbackComplete'] === undefined) return false;
    return true;
}

export function MenuOrderOwnFromJSON(json: any): MenuOrderOwn {
    return MenuOrderOwnFromJSONTyped(json, false);
}

export function MenuOrderOwnFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderOwn {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'business': json['business'],
        'subtotal': json['subtotal'],
        'stripeTotal': json['stripeTotal'],
        'serviceFees': json['serviceFees'] == null ? undefined : ((json['serviceFees'] as Array<any>).map(MenuOrderServiceFeeFromJSON)),
        'tax': json['tax'],
        'deliveryCharge': json['deliveryCharge'],
        'tipDelivery': json['tipDelivery'] == null ? undefined : json['tipDelivery'],
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(MenuOrderDiscountFromJSON)),
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'status': json['status'] == null ? undefined : MenuOrderStatusFromJSON(json['status']),
        'address': AddressFromJSON(json['address']),
        'handoff': json['handoff'] == null ? undefined : HandoffOptionsFromJSON(json['handoff']),
        'pickupCode': json['pickupCode'] == null ? undefined : json['pickupCode'],
        'orderItems': ((json['orderItems'] as Array<any>).map(MenuOrderItemFromJSON)),
        'callbackComplete': json['callbackComplete'],
        'exceededSlippage': json['exceededSlippage'] == null ? undefined : json['exceededSlippage'],
        'uberEatsUuid': json['uberEatsUuid'] == null ? undefined : json['uberEatsUuid'],
        'orderUuid': json['orderUuid'] == null ? undefined : json['orderUuid'],
        'refunds': json['refunds'] == null ? undefined : ((json['refunds'] as Array<any>).map(OrderRefundFromJSON)),
    };
}

export function MenuOrderOwnToJSON(json: any): MenuOrderOwn {
    return MenuOrderOwnToJSONTyped(json, false);
}

export function MenuOrderOwnToJSONTyped(value?: MenuOrderOwn | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'business': value['business'],
        'subtotal': value['subtotal'],
        'stripeTotal': value['stripeTotal'],
        'serviceFees': value['serviceFees'] == null ? undefined : ((value['serviceFees'] as Array<any>).map(MenuOrderServiceFeeToJSON)),
        'tax': value['tax'],
        'deliveryCharge': value['deliveryCharge'],
        'tipDelivery': value['tipDelivery'],
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(MenuOrderDiscountToJSON)),
        'transactionHash': value['transactionHash'],
        'status': MenuOrderStatusToJSON(value['status']),
        'address': AddressToJSON(value['address']),
        'handoff': HandoffOptionsToJSON(value['handoff']),
        'pickupCode': value['pickupCode'],
        'orderItems': ((value['orderItems'] as Array<any>).map(MenuOrderItemToJSON)),
        'callbackComplete': value['callbackComplete'],
        'exceededSlippage': value['exceededSlippage'],
        'uberEatsUuid': value['uberEatsUuid'],
        'orderUuid': value['orderUuid'],
        'refunds': value['refunds'] == null ? undefined : ((value['refunds'] as Array<any>).map(OrderRefundToJSON)),
    };
}

